import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';


const ThinkingProgressIndicator = ({ text = "Thinking..." }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 150, 
        p: 3,
        borderRadius: '8px',
      }}
    >
      <CircularProgress 
        size={36}          
        thickness={5}      
        color="primary"    
      />
      <Typography 
        variant="body1" 
        sx={{ 
          mt: 2,           
          color: 'text.secondary', 
          fontStyle: 'italic'
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default ThinkingProgressIndicator;